<div class="d-flex align-items-center local-container-paddings-{{secondaryData?.length > 1 ? 'small' : 'big'}}">
  <div class="local-primary-icon mr-1 flex-shrink-0">
    <ng-container [ngTemplateOutlet]="primaryIconContentTemplate">
    </ng-container>
  </div>

  <ng-template #itemTemplate
    let-item="item"
    let-dataTestAttr="dataTestAttr">
    @switch (true) {
      @case (!!item.routerLink) {
        <a
          class="text-ellipsis"
          [attr.data-test]="dataTestAttr"
          [routerLink]="item.routerLink"
        [queryParams]="item.routerLinkQueryParams">{{ item.text }}</a>
      }
      @case (!!item.href) {
        <a
          class="text-ellipsis"
          [attr.data-test]="dataTestAttr"
        [href]="item.href">{{ item.text }}</a>
      }
      @default {
        <span
          [attr.data-test]="dataTestAttr"
        class="text-ellipsis text-secondary-dark">{{ item.text }}</span>
      }
    }
  </ng-template>

  <div class="flex-fill me-auto overflow-hidden search-card">
    <div class="d-flex flex-column local-text-near-primary-icon justify-content-center">
      <ng-template #secondaryDataTemplate
        let-secondaryDataItem=secondaryDataItem>
        <div class="d-flex text-medium text-secondary pt-1">
          <div class="d-inline mr-1">
            @if (secondaryDataItem.label) {
              <span
              class="local-colon-after">{{ secondaryDataItem.label }}</span>
            }

            @if (secondaryDataItem.labelIconClass) {
              <i
              [class]="secondaryDataItem.labelIconClass"></i>
            }
          </div>

          <div class="d-inline text-truncate local-values-container" [ngClass]="{ 'dotted-left': secondaryDataItem.alignRight }">
            @for (item of secondaryDataItem.items; track item) {
              <ng-container [ngTemplateOutlet]="itemTemplate"
                [ngTemplateOutletContext]="{ item: item, dataTestAttr: 'secondary' }">
              </ng-container>
            }
          </div>
        </div>
      </ng-template>

      @if (titleData) {
        <div
          class="text-ellipsis local-title mb-auto"
          [class.mb-auto]="secondaryData?.length">
          <ng-container [ngTemplateOutlet]="itemTemplate"
            [ngTemplateOutletContext]="{ item: titleData, dataTestAttr: 'title' }">
          </ng-container>
        </div>
      }

      @if (secondaryData?.length) {
        <div>
          <ng-container [ngTemplateOutlet]="secondaryDataTemplate"
            [ngTemplateOutletContext]="{ secondaryDataItem: secondaryData[0] }">
          </ng-container>
        </div>
      }
    </div>

    @for (secondaryDataItem of secondaryData?.slice(1); track secondaryDataItem) {
      <ng-container [ngTemplateOutlet]="secondaryDataTemplate"
        [ngTemplateOutletContext]="{ secondaryDataItem: secondaryDataItem }">
      </ng-container>
    }
  </div>

  @if (secondaryIconContentTemplate) {
    <div
      class="local-secondary-icon align-self-center local-ml-1 flex-shrink-0">
      <ng-container [ngTemplateOutlet]="secondaryIconContentTemplate">
      </ng-container>
    </div>
  }

  @if (cardLink?.routerLink) {
    <a
      data-test="card-link"
      (click)="toggleDropdown()"
      class="stretched-link local-hidden"
      [routerLink]="cardLink.routerLink"
      [queryParams]="cardLink.routerLinkQueryParams">
    </a>
  }

  @if (cardLink?.href) {
    <a
      data-test="card-link"
      (click)="toggleDropdown()"
      class="stretched-link local-hidden"
      [href]="cardLink.href">
    </a>
  }

</div>
